export default __webpack_public_path__ + "static/8a0fbd31f4f8a1e409236f096a5e2f9f.jpg";